import React, {useState, useEffect, useMemo} from 'react';
import styles from './BindItems.module.css';

import { SelectMultiCheckboxSimple } from '../SelectMultiCheckboxSimple/SelectMultiCheckboxSimple';
import cn from 'classnames';
import Button from '../Button/Button';
import {manageRulesApi} from '../../helpers/ManageRuleAPI';
import {getAllRulesUrl} from '../../helpers/constants';
import useApi from '../../hooks/useApi.hook';
import BindedItem from './BindedItem/BindedItem';

export default function BindItems({
	valueBind,
	options = [],
	setErrorApi,
	getRules,
	rulesDict,
	bindType = 'prof'
}) {

	console.log(valueBind);
	const api = useApi();
	const [selectedOptions, setSelectedOptions] = useState([]);
	const itemDict = useMemo(
		() => Object.fromEntries((options || []).map(({ value, label }) => [value, label])),
		[options]
	);

	const bindInses = () => {
		const ids = selectedOptions.map(id => Number(id));
		if (ids.length === 0) {
			getRules();
			return;
		}
		const payload = bindType === 'prof'
			? {
				instruction_ids: ids,
				profession_ids: [Number(valueBind)]
			}
			: {
				instruction_ids: [Number(valueBind)],
				profession_ids: ids
			};
		manageRulesApi(
			api,
			'POST',
			payload,
			null,
			setErrorApi,
			getRules,
		);
	};

	useEffect(() => {
		if (Number(valueBind) === 0) {
			setSelectedOptions([]);
			return;
		}
		const selected = bindType === 'prof'
			? Object.values(rulesDict)
				.filter(rule => Number(rule.profession_id) === Number(valueBind))
				.map(rule => String(rule.instruction_id))
			: Object.values(rulesDict)
				.filter(rule => Number(rule.instruction_id) === Number(valueBind))
				.map(rule => String(rule.profession_id));
		setSelectedOptions(selected);
	}, [valueBind, rulesDict, bindType]);

	return (
		<div className={styles.filtersTable}>
			<div className={styles.selectBox}>
				<label
					className={`${styles.labelSelect} ${selectedOptions.length ? styles.labelActive : ''}`}
				>
					{bindType === 'prof' ? 'Инструкции:' : 'Профессии:'}
				</label>
				<SelectMultiCheckboxSimple
					options={options}
					value={selectedOptions}
					onChange={setSelectedOptions}
					placeholder={bindType === 'prof' ? 'Фильтр по инструкции' : 'Фильтр по профессии'}
				/>
			</div>
			<div className={styles.bind_button_box}>
				<Button
					className={cn(styles.bind_button, {
						[styles.disabled]: Number(valueBind) === 0
					})}
					onClick={bindInses}>
						Привязать
				</Button>
			</div>
			<div className={styles.binds_box}>
				{Object.values(rulesDict)
					.filter(rule => bindType === 'prof' ? String(rule.profession_id) === String(valueBind) : String(rule.instruction_id) === String(valueBind))
					.map(rule => (
						<BindedItem
							key={rule.id}
							api={api}
							rule_id={rule.id}
							item_id={bindType === 'prof' ? rule.instruction_id : rule.profession_id}
							itemDict={itemDict}
							getRules={getRules}
							setErrorApi={setErrorApi}
							deleteEndpoint={getAllRulesUrl}
						/>
					))}
			</div>
		</div>
	);
}
